import * as React from 'react';
import Text from 'components/Text';
import Time from 'components/Time';
import { UpgradePlanQuote } from 'admin/components/AdminUpgradePlan/AdminUpgradePlanContainer';

import '../styles/AdminUpgradePlanQuoteReviewBox.scss';

type Props = {
  orgName: string;
  startDate: string;
  endDate: string;
};

export default function AdminUpgradePlanQuoteReviewBox(props: Props) {
  const { orgName, startDate, endDate } = props;

  return (
    <div className="AdminUpgradePlanQuoteReviewBox">
      <div className="AdminUpgradePlanQuoteReviewBox-org">
        <div>
          <Text element="div" size="medium" weight="semibold">
            Remind plan for 1 year
          </Text>
          <Text element="div" color="thunder">
            {orgName}
          </Text>
          <Text element="div" color="thunder">
            <Time
              date={new Date(startDate)}
              month="long"
              day="numeric"
              year="numeric"
            />{' '}
            to{' '}
            <Time date={new Date(endDate)} month="long" day="numeric" year="numeric" />
          </Text>
        </div>
      </div>
    </div>
  );
}

export { AdminUpgradePlanQuoteReviewBox };
